<template>
  <div>
    <div class="loading" v-if="isLoading">
      <van-loading type="spinner" size="36" />
    </div>
    <div class="success_container" v-else>
      <img class="sure" :src="imageUrl + 'organization/sure.png'" />
      <div class="text">提交成功</div>
      <div class="desc">我们将会尽快与您联系</div>
      <!-- <div class="btn flex-x-center-center" catch:tap="goHome">返回首页</div> -->
      <div class="flex-x-center-center">
        <!-- <div class="btn knows_btn" catch:tap="goBack">知道了</div> -->
        <!-- <div class="btn to_shop_btn" @click="goShop">去商城看看</div> -->
        <div class="footer-text" @click="onDownload">下载APP</div>
      </div>
    </div>
  </div>
</template>

<script>
import { addInvestmentSettle, getAppVersionConfig } from '@/api/data'
const imageUrl = 'https://ysh-cdn.kaidicloud.com/test/'
import { getYYWxLink } from '@/api/data'
import { Toast, Loading } from 'vant'
export default {
  components: {
    [Toast.name]: Toast,
    [Loading.name]: Loading
  },
  data() {
    return {
      imageUrl,
      yywxlink: '',
      isMiniProgram: false,
      isLoading: false,
      downloadUrl: '', // 安卓路径
      time: 0,
      time1: 0,
      time2: 0
    }
  },

  async created() {
    // 判断是否是小程序环境
    this.isMiniProgram = /miniProgram/i.test(navigator.userAgent.toLowerCase())
    // 获取小程序链接
    getYYWxLink('/pages/home/index').then(res => {
      if (res.data.state !== 1) return
      this.yywxlink = res.data.data.urlscheme
    })
    // 是否登录触发提交
    const { info } = this.$route.query
    if (info) {
      this.isLoading = true
      // alert('info===' + info)
      const _info = JSON.parse(decodeURIComponent(info))
      const {
        data: { msg, state }
      } = await addInvestmentSettle(_info)
      if (state !== 1) {
        Toast({
          message: `<div style="min-width: 96px;padding:6px 8px;font-size:16px;line-height:1.6;">${msg}</div>`,
          type: 'html'
        })
        setTimeout(() => {
          wx.miniProgram.redirectTo({
            url: '/subpackage/webview/index?url=https://ysh-h5-test-s02a.kaidicloud.com/yyds-investment'
          })
        }, 1500)
        return
      }
      setTimeout(() => {
        this.isLoading = false
        document.title = '提交成功'
      }, 1000)
    } else {
      document.title = '提交成功'
    }
  },
  async mounted() {
    this.fetchData()
  },
  methods: {
    goShop() {
      if (this.isMiniProgram) {
        wx.miniProgram.navigateTo({
          url: '/pages/home/index'
        })
      } else {
        window.location.href = this.yywxlink
      }
    },
    async fetchData() {
      const res = await getAppVersionConfig('ysh_official_website_product')
      this.downloadUrl = res.data.data.fullUpdateInfo.downloadUrl
    },


    // 下载app
    onDownload() {
      //判断浏览器
      var u = navigator.userAgent
      if (/MicroMessenger/gi.test(u)) {
        // 引导用户在浏览器中打开
        alert('请在浏览器中打开')
        return
      }

      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        //Android
        this.openApp('yshapp://', 'Android')
      } else if (u.indexOf('iPhone') > -1) {
        //IOS
        this.openApp('yshapp://', 'ios')
      }
    },

    openApp(src, type) {
      let hasApp = true,
        t = 1000,
        t1 = Date.now()

      // 通过iframe的方式试图打开APP，如果能正常打开，会直接切换到APP，并自动阻止a标签的默认行为
      // 否则打开a标签的href链接
      var ifr = document.createElement('iframe')
      ifr.src = src
      ifr.style.display = 'none'
      document.body.appendChild(ifr)
      let that = this
      window.setTimeout(function() {
        if (!hasApp) {
          if (type == 'Android') {
            //由于打开需要1～2秒，利用这个时间差来处理－－打开app后，返回h5页面会出现页面变成app下载页面，影响用户体验
            // alert('请下载APP')
            window.location.href = that.downloadUrl
          } else {
            // alert('请下载APP')
            window.location.href = 'https://apps.apple.com/app/apple-store/id1631363552?pt=124916174&ct=home&mt=8'
          }
        }
        document.body.removeChild(ifr)
      }, 2000)

      this.openTimer = setTimeout(function() {
        //启动app时间较长处理
        let t2 = Date.now()

        that.time1 = t1
        that.time2 = t2
        if (t2 - t1 < t + 100) {
          that.time = t2 - t1
          hasApp = false
        }
      }, t)

      return hasApp
    }
  }
}
</script>

<style lang="less" scoped>
.success_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
}
.loading {
  width: 100%;
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.sure {
  width: 386px;
  height: 284px;
  margin-bottom: 16px;
  margin-top: 15vh;
}
.text {
  height: 56px;
  font-size: 40px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333;
  line-height: 56px;
  margin-bottom: 20px;
}
.desc {
  height: 48px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #999;
  line-height: 48px;
}
.btn {
  width: 232px;
  height: 80px;
  margin-top: 100px;
  border-radius: 40px;
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 400;
  line-height: 76px;
  text-align: center;
}

.knows_btn {
  color: #666;
  border: 2px solid #bbbbbb;
}

.to_shop_btn {
  width: 486px;
  height: 80px;
  background: #fcedea;
  border: 2px solid #ff4e00;
  font-weight: 600;
  color: #ff4e00;
}
.footer-text {
  width: 540px;
  height: 84px;
  background: #f93809;
  border-radius: 42px;
  font-size: 30px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 72px;
}
</style>
